import Button from "components/common/Button";
import CustomTable from "components/common/CustomTable";
import SynthTooltip from "components/common/SynthTooltip";
import VendorAvatar from "components/common/VendorAvatar";
import { formatMoney, getCurrencyFromCurrencyCode } from "helpers";
import React from "react";
import { currencies } from "variables";

type AddProductProps = {
    resultMessage: {
        message: string;
        product?: Record<string, any>;
        bundle?: {
            bundleName: string;
            sku: string;
            bundleItems: Record<string, any>[];
        };
        success: boolean;
    };
    toolName: string;
};
const AddProduct = ({ resultMessage, toolName }: AddProductProps) => {
    const tableHeader = [
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Product name
                    </span>

                    <SynthTooltip
                        content={
                            "The unique name identifying this specific item in your inventory."
                        }
                        divId={"add-product-product-column"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    />
                </div>
            ),
            widthClass: "w-[31%] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">SKU No. </span>

                    {/* <SynthTooltip
                        content={""}
                        divId={"add-product-sku"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    /> */}
                </div>
            ),
            widthClass: "w-[23%] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Current stock level
                    </span>

                    <SynthTooltip
                        content={
                            "The actual quantity of the product currently available in stock for sale or use at this moment."
                        }
                        divId={"add-product-cost-forecast-column"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    />
                </div>
            ),
            widthClass: "w-[23%] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">Unit cost</span>

                    {/* <SynthTooltip
                        content={
                            ""
                        }
                        divId={"add-product-unit-cost"}
                        icon={<i className="ri-information-line text-slate-600 text-sm"></i>}
                    /> */}
                </div>
            ),
            widthClass: "w-[23%] ",
        },
    ];

    const tableBody = resultMessage?.bundle?.bundleItems?.map((item, idx) => {
        return [
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-gm-75  py-2`}
                    >
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-3">
                                {item?.inventory?.productImageDetails?.productImages?.[0] ? (
                                    <VendorAvatar
                                        imageSrc={
                                            item?.inventory?.productImageDetails?.productAvatar ||
                                            item?.inventory?.productImageDetails?.productImages?.[0]
                                        }
                                        size={32}
                                        name={item?.inventory?.productName}
                                        containerClassname="!rounded-md"
                                    />
                                ) : (
                                    <div className="w-8 h-8 rounded shrink-0 flex items-center justify-center bg-slate-200 ">
                                        <i className="ri-box-2-fill text-lg text-slate-500"></i>
                                    </div>
                                )}
                                <p className="">{item?.inventory?.productName || ""}</p>
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-gm-75  py-2 break-all`}
                    >
                        <div>
                            <p className="text-gm-75 text-xs  ">{item?.inventory?.sku || "N/A"}</p>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-gm-75  py-2`}
                    >
                        <p className="">
                            {item?.inventory?.productStockDetails?.stockLevel
                                ? `${formatMoney()?.format(
                                      item?.inventory?.productStockDetails?.stockLevel ?? 0
                                  )} ${
                                      item?.inventory?.productStockDetails?.unitOfMeasurement || ""
                                  }`
                                : "N/A"}
                        </p>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-gm-75  py-2`}
                    >
                        <p className="">
                            {item?.inventory?.salesPrice?.amount
                                ? `${getCurrencyFromCurrencyCode(
                                      item?.inventory?.salesPrice?.currency
                                  )}
                            ${formatMoney()?.format(item?.inventory?.salesPrice?.amount)}`
                                : "N/A"}
                        </p>
                    </div>
                ),
                widthClass: " !border-b",
            },
        ];
    });

    return (
        <div>
            {toolName === "AddSingleProduct" && resultMessage?.success && (
                <div
                    className={`w-fit border border-[#E2E8F0] !min-w-[536px] rounded-[10px] p-5  space-y-3 shadow-[0px_4px_8px_0px_rgba(16,24,40,0.03)]  `}
                >
                    <div className="flex justify-between items-center gap-4">
                        <div className="flex items-center gap-2">
                            <div className="w-11 h-11 rounded shrink-0 flex items-center justify-center bg-slate-200 ">
                                <i className="ri-box-2-fill text-2xl text-slate-500"></i>
                            </div>

                            <div>
                                <p className="text-sm">{resultMessage?.product?.productName}</p>
                                <p className=" text-slate-500 text-sm">
                                    SKU: {resultMessage?.product?.sku}
                                </p>
                            </div>
                        </div>
                        <div className="bg-[#DCFCE7] text-[#16A34A] border border-[#16A34A] text-sm rounded-[3px] px-2 py-0.5">
                            Product added successfully
                        </div>
                    </div>

                    <div className="space-y-2">
                        <div className="flex text-sm pl-2 gap-2">
                            <div className="flex items-center gap-2">
                                <i className="w-1 h-1 rounded-full bg-slate-950"></i>

                                <p className="text-slate-950">Category:</p>
                            </div>
                            <p className="text-slate-500">
                                {resultMessage?.product?.inventoryCategory}
                            </p>
                        </div>

                        <div className="flex text-sm pl-2 gap-2">
                            <div className="flex items-center gap-2">
                                <i className="w-1 h-1 rounded-full bg-slate-950"></i>

                                <p className="text-slate-950">Channel:</p>
                            </div>
                            <p className="text-slate-500">
                                {resultMessage?.product?.channel || "N/A"}
                            </p>
                        </div>
                        <div className="flex text-sm pl-2 gap-2">
                            <div className="flex items-center gap-2">
                                <i className="w-1 h-1 rounded-full bg-slate-950"></i>

                                <p className="text-slate-950">Is this a perishable goods?</p>
                            </div>
                            <p className="text-slate-500">
                                {resultMessage?.product?.isProductPerishable ? "Yes" : "No"}
                            </p>
                        </div>
                        <div className="flex text-sm pl-2 gap-2">
                            <div className="flex items-center gap-2">
                                <i className="w-1 h-1 rounded-full bg-slate-950"></i>

                                <p className="text-slate-950">Product price:</p>
                            </div>
                            <p className="text-slate-500">
                                {getCurrencyFromCurrencyCode(
                                    resultMessage?.product?.salesPrice?.currency
                                )}{" "}
                                {formatMoney()?.format(resultMessage?.product?.salesPrice?.amount)}{" "}
                            </p>
                        </div>

                        <Button
                            btnText="View product on inventory"
                            btnClassname="!text-g-75 !font-rocGroteskMedium !mt-3 !w-fit !py-2 !px-3 "
                        />
                    </div>
                </div>
            )}

            {toolName === "AddBundledProduct" && resultMessage?.success && (
                <div>
                    <p className="text-sm text-g-75 border-x border-t border-slate-200 rounded-t-md px-3 py-4">
                        {resultMessage?.bundle?.bundleName} bundle
                    </p>
                    {resultMessage?.bundle?.bundleItems?.length > 0 && (
                        <CustomTable
                            tableBody={tableBody}
                            tableHeader={tableHeader}
                            isCellBordered={true}
                            stickyHeader={true}
                            headerContainerClass="!bg-slate-50 "
                            headerItemClass="font-rocGroteskMedium "
                            tableClass="mb-4"
                            isScrollable={false}
                            scrollWithin={false}
                            renderEmptyTable={() => null}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default AddProduct;
